import { useEffect, useMemo } from 'react'
import { TreeNodeOrNodeSlug } from 'react-common'
import { useParams } from 'react-router-dom'
import { ActivityType } from '@/api/models/activity'
import { GradeRevealPolicy, ObjectiveWorkflowState } from '@/api/models/aggregate'
import { useSidebarLayers } from '@/features/layout/hooks/useSidebarLayers'
import { LearnerAppRemote } from '@/features/microFrontend/learnerMF/LearnerAppRemote'
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs'
import { useGetCourseDetailsSteps } from '@/hooks/useGetCourseDetailsSteps'
import { useGetObjectiveAccessByIdQuery } from '@/store/api/aggregatesApi'

const CourseDetailsMF = () => {
  const { setMyCourseBreadcrumbs } = useBreadcrumbs()
  const { setLayers } = useSidebarLayers()

  const { objectiveId = '' } = useParams()

  const { data: aggregate } = useGetObjectiveAccessByIdQuery(objectiveId, { skip: !objectiveId })

  const objective = useMemo(() => aggregate?.objective, [aggregate])

  useEffect(() => {
    if (!objective) return

    setMyCourseBreadcrumbs([{ name: objective.name } as TreeNodeOrNodeSlug])
  }, [setMyCourseBreadcrumbs, objective])

  const getSupportReview = () => {
    if (!objective?.activity?.supportReview) {
      return false
    }

    if (aggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.state !== ObjectiveWorkflowState.finished) {
      return false
    }

    switch (aggregate?.gradeRevealPolicy) {
      case GradeRevealPolicy.Never:
        return false
      case GradeRevealPolicy.AfterDate:
        // to show review, reveal date must be in the past
        return new Date(aggregate?.gradeRevealDate || '').getTime() < Date.now()
      case GradeRevealPolicy.None:
      case GradeRevealPolicy.AfterFinish:
      default:
        return true
    }
  }

  const { sidebarLayers: sidebarItems } = useGetCourseDetailsSteps({
    isLti: objective?.activity?.type === ActivityType.lti,
    inProgress:
      aggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.state === ObjectiveWorkflowState.inProgress,
    objectiveId,
    supportReview: getSupportReview(),
  })

  useEffect(() => {
    setLayers(sidebarItems)
  }, [setLayers, sidebarItems])

  return <LearnerAppRemote />
}

export default CourseDetailsMF
